<template>
  <div
      class="flex flex-col w-full min-w-[160px] max-w-[450px] min-h-[270px] rounded-md bg-white relative bg-white">
  </div>
</template>

<script setup>
</script>